function fillAppsflyerEventNameParams(afEventName: string, params: Record<string, string>) {
    let result = afEventName;
    Object.keys(params).forEach(paramKey => {
        result = result.replaceAll(`{{${paramKey}}}`, params[paramKey]);
    });
    return result;
}

export default fillAppsflyerEventNameParams;
